import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Logos from '../../../logos';
import styles from './project-logo.module.css';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';

const ProjectLogo = ({ logoImage, slug, isHome, returnSection }) => {
  const animationConfig = {
    delay: 600,
    duration: 800,
    easing: easings.easeCubicOut,
  };

  const renderProjectLogo = animation => {
    return (
      <div style={animation} className={styles.svg}>
        <Logos slug={slug} />
      </div>
    );
  };
  const renderDefaultAnimation = () => {
    return (
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: 1 }}
        config={animationConfig}
      >
        {animation => renderProjectLogo(animation)}
      </Spring>
    );
  };

  const renderHomeAnimation = () => {
    return (
      <Spring
        from={{ opacity: 0 }}
        to={{ opacity: returnSection === 'active' ? 1 : 0 }}
        config={animationConfig}
      >
        {animation => renderProjectLogo(animation)}
      </Spring>
    );
  };

  if (isHome !== true) {
    return renderDefaultAnimation();
  } else {
    return renderHomeAnimation();
  }
};

ProjectLogo.propTypes = {};

export default ProjectLogo;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-logo/index.js